export const toolbarSettings = {
    showLangSwitch: true,
  };
  